import { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { setValToLS } from "../helpers";

const Steps = ({ on, user }) => {
	const history = useHistory();

	const handleSignout = () => {
		setValToLS("auth", null, true);
		setValToLS("order", null, true);
		history.push("/");
	};

	return (
		<Fragment>
			{user && (
				<div className="steps">
					<h4>{`Welcome, ${user.fname}`}</h4>

					<button
						type="button"
						className="btn-alt"
						onClick={() => handleSignout()}
					>
						Sign Out
					</button>

					<ol>
						{[
							{
								id: 1,
								name: "Select Sponsor Level",
							},
							{
								id: 2,
								name: "Enter Billing Information",
							},
							{
								id: 3,
								name: "Allocate Golf / Sporting Clays ",
							},
							{
								id: 4,
								name: "Upload Logo",
							},
							{
								id: 5,
								name: "Answer Questions",
							},
							{
								id: 6,
								name: "Submit Payment Method",
							},
							{
								id: 7,
								name: "Completed Registration Submitted",
							},
						].map((item) => {
							return (
								<li className={item.id === on ? "selected" : ""} key={item.id}>
									<span>{item.name}</span>
								</li>
							);
						})}
					</ol>
				</div>
			)}
		</Fragment>
	);
};

export default Steps;
